import { AlertCircle, CheckCircle2, Info, TriangleAlert } from "lucide-react";

export const COMMENT_TAB_ID = "comments";
export const LOG_EVENT_TAB_ID = "log-events";
export const MAX_COLLAPSED_LENGTH = 500;
export const MAX_COLLAPSED_LINES = 3;

export const EVENT_TYPE_CONFIG = {
  SUCCESS: {
    container: "border-green-200 hover:border-green-300",
    badge: "bg-green-50 text-green-700",
    icon: CheckCircle2,
    iconClassName: "text-green-600",
  },
  INFO: {
    container: "border-blue-200 hover:border-blue-300",
    badge: "bg-blue-50 text-blue-700",
    icon: Info,
    iconClassName: "text-blue-600",
  },
  WARNING: {
    container: "border-yellow-200 hover:border-yellow-300",
    badge: "bg-yellow-50 text-yellow-700",
    icon: TriangleAlert,
    iconClassName: "text-yellow-600",
  },
  ERROR: {
    container: "border-red-200 hover:border-red-300",
    badge: "bg-red-50 text-red-700",
    icon: AlertCircle,
    iconClassName: "text-red-600",
  },
};
